import React, { useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { useLanguage } from '../context/LanguageContext';
import './Services.css';

const services = [
  {
    id: 'taxi',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M12 2a10 10 0 0110 10c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Servicio de taxi 24/7',
    description: 'Disponibles las 24 horas, los 7 días de la semana.',
  },
  {
    id: 'empresas-faenas',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Servicios para empresas y faenas mineras (convenios)',
    description: 'Convenios con empresas. Traslados de personal y trabajadores.',
  },
  {
    id: 'aeropuerto',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Traslado al Aeropuerto (ida y vuelta)',
    description: 'Servicio puntual y confiable al aeropuerto.',
  },
];

function Services() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);

  const servicesData = [
    { id: 'taxi', title: t('services.taxi.title'), desc: t('services.taxi.desc') },
    { id: 'empresas', title: t('services.empresas.title'), desc: t('services.empresas.desc') },
    { id: 'aeropuerto', title: t('services.aeropuerto.title'), desc: t('services.aeropuerto.desc') },
  ];

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        const cards = section.querySelectorAll('.service-card');
        cards.forEach((el, i) => {
          animate(el, {
            opacity: [0, 1],
            y: [30, 0],
            duration: 550,
            delay: i * 120,
            ease: 'outExpo',
          });
        });
        observer.disconnect();
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="services">
      <h2 id="servicios-title" className="section-title">{t('services.title')}</h2>
      <div className="services-grid">
        {services.map((s, i) => (
          <article key={s.id} className="service-card">
            <div className="service-icon" aria-hidden="true">{s.icon}</div>
            <h3 className="service-title">{servicesData[i].title}</h3>
            <p className="service-desc">{servicesData[i].desc}</p>
          </article>
        ))}
      </div>
    </div>
  );
}

export default Services;
